import { render } from "./tp4d.vue?vue&type=template&id=9277b16c"
import script from "./tp4d.vue?vue&type=script&lang=js"
export * from "./tp4d.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__